import {isFeatureEnabled} from '@github-ui/feature-flags'
import {jsonRoute} from '@github-ui/react-core/json-route'
import {registerNavigatorApp} from '@github-ui/react-core/register-app'

import {App} from './App'
import {AttestationDetail} from './pages/AttestationDetail'
import {AttestationsIndex} from './pages/AttestationsIndex'
import {AttestationsIndexWithFilter} from './pages/AttestationsIndexWithFilter'

registerNavigatorApp('repo-attestations', () => {
  // The feature flag check is placed inside the callback to ensure it runs at runtime,
  // avoiding SSR module-level execution errors. This prevents accessing client-side
  // environment variables before they are loaded, which is not supported during SSR.
  const showFilter = isFeatureEnabled('attestations_filtering')

  return {
    App,
    routes: [
      jsonRoute({
        path: '/:owner/:repo/attestations',
        Component: showFilter ? AttestationsIndexWithFilter : AttestationsIndex,
      }),
      jsonRoute({path: '/:owner/:repo/attestations/:attestation_id', Component: AttestationDetail}),
    ],
  }
})
